import axios from './axiosConfig';

const api = {
    // 获取所有岗位类型
    listPostTypes: () => axios.get('/postType/listPostTypes')
};
export default api;
